import { render, staticRenderFns } from "./Report-8.vue?vue&type=template&id=37a2fb02&scoped=true"
import script from "./Report-8.vue?vue&type=script&lang=js"
export * from "./Report-8.vue?vue&type=script&lang=js"
import style0 from "./Report-8.vue?vue&type=style&index=0&id=37a2fb02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a2fb02",
  null
  
)

export default component.exports